import { faCopyright } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import InfoService from '../service/InfoService'

export const Footer: FC<{}> = () => {
  const { t } = useTranslation()
  const [version, setVersion] = useState({} as any)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    InfoService.getVersions()
      .then((versions: any[]) => setVersion(versions.find((v) => v.productname === 'eperi Gateway for Cloud Apps')))
      .finally(() => setLoaded(true))
  }, [])

  return (
    <>
      <hr className='bg-primary pt-1 mt-0 mb-0' />
      <Navbar variant='dark' bg='dark' className='p-0 pl-3 mb-0 shadow-sm header'>
        <Navbar.Brand className='mr-1 mb-1'>
          <FontAwesomeIcon icon={faCopyright} size='xs' />
        </Navbar.Brand>
        <Navbar.Collapse>
          <Navbar.Text>
            <a target='_blank' href='https://eperi.com' rel='noopener noreferrer'>
              {t('copyRight')}
            </a>
          </Navbar.Text>
        </Navbar.Collapse>

        <Nav className='ml-auto pr-3'>
          {loaded && version.versionnumber && (
            <Nav.Link href='./info/version' className='text-primary cursor-pointer'>{`${version.versionnumber}-${version.buildnumber}`}</Nav.Link>
          )}

          {/* 
          Language change diabled for now
          <Navbar.Text>Language:</Navbar.Text>
          <Form.Control as='select' defaultValue={i18n.language} onChange={(e: any) => changeLanguage(e.target.value)}>
            <option value='en'>English</option>
            <option value='de'>Deutsch</option>
          </Form.Control>
          */}
        </Nav>
      </Navbar>
    </>
  )
}
